/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RelationshipsOthersIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RelationshipsOthersIcon({
  children,
  viewPath = "/DesignSystem/Svgs/RelationshipsOthersIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="RelationshipsOthersIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-1l30Gk': alignSelf,'--mt-2-1l30Gk': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1l30Gk': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1l30Gk': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1l30Gk': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1l30Gk': opacity,'--w-10-1l30Gk': typeof width === 'number' ? `${width}px` : width,'--h-11-1l30Gk': typeof height === 'number' ? `${height}px` : height,'--f-12-1l30Gk': fill,'--a-7-1l30Gk': isAnimated ? animation : "none",'--sd-8-1l30Gk': isAnimated ? strokeDashoffset : 0,'--sd-9-1l30Gk': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="RelationshipsOthersIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.464 5.821a2.321 2.321 0 114.643 0 2.321 2.321 0 01-4.643 0zm9.75-2.321a2.321 2.321 0 100 4.643 2.321 2.321 0 000-4.643zm-1.751 6.832c.356-.665.914-1.26 1.751-1.26.838 0 1.396.595 1.752 1.26.36.674.589 1.543.737 2.372.149.837.223 1.669.26 2.288a22.55 22.55 0 01.036.965v.057l.001.016v.005h-.464H17a.465.465 0 01-.464.465h-4.643a.464.464 0 01-.464-.464h.464-.464v-.079l.004-.212c.005-.183.014-.442.033-.752.037-.62.11-1.452.26-2.289.148-.829.376-1.698.737-2.372zM4 9.536c0-.257.208-.465.464-.465h4.643c.257 0 .464.208.464.465h-.464.464v.078l-.004.213c-.005.182-.014.441-.033.752-.037.62-.11 1.452-.26 2.288-.148.83-.376 1.699-.737 2.372-.356.665-.913 1.261-1.751 1.261-.838 0-1.395-.596-1.752-1.26-.36-.674-.589-1.544-.737-2.373a20.165 20.165 0 01-.26-2.288 22.37 22.37 0 01-.036-.965v-.057L4 9.542v-.006h.464H4z"
 style={{'--f-12-1l30Gk': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}